import axios from "axios";

// const BASE_URL = "http://localhost:3000/login-unique-users"; // local
const BASE_URL =
  "https://es-product-search.devops.multpex.com.br/login-unique-users";

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": "weijefioejv03iehjvwiov0w3ijv",
  },
});

export const treinamentoUsuariosService = {
  listar(filtros = {}) {
    const params = {};
    if (filtros.tenant) params.tenant = filtros.tenant;
    if (filtros.userEmail) params.userEmail = filtros.userEmail;
    if (filtros.userSap) params.userSap = filtros.userSap;
    return api.get("", { params });
  },

  criar(dados) {
    return api.post("", dados);
  },

  editar(id, dados) {
    return api.put(`/${id}`, dados);
  },

  deletar(id, dados = {}) {
    return api.delete(`/${id}`, { data: dados });
  },
};
